import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { RouteAction } from '@core/action/action';
import { CustomValidators } from '@core/custom-validators/validators';
import { TipoContatoEnum } from '@core/models/entidade';
import { NomePaginaEnum } from '@core/models/nome-pagina.enum';
import { AreaAtuacaoService } from '@core/services/areaAtuacaoService';
import { CEPService } from '@core/services/cep.service';
import { CidadeService } from '@core/services/cidade.service';
import { MessageService } from '@core/services/message.service';
import { PaisService } from '@core/services/pais.service';
import { TipoContatoService } from '@core/services/tipocontato.service';
import { UFService } from '@core/services/uf.service';
import { VinculoService } from '@core/services/vinculo.service';
import { EntidadeSharedDataService } from '@modules/entidade/entidade-shared-data.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-outros-contatos-vinculo-form',
  templateUrl: './outros-contatos-vinculo-form.component.html',
  styleUrls: ['./outros-contatos-vinculo-form.component.scss']
})
export class OutrosContatosVinculoFormComponent implements OnInit, OnChanges {

  @Input() contato: any;
  @Input() dataSet: any;
  @Input() paginaEntidade: boolean = false;
  @Input() nomePagina!: NomePaginaEnum;
  @Output() dadosOutrosContatosEmit = new EventEmitter<any>();
  @Output() dadosTipoContatoIdEmit = new EventEmitter<any>();

  @Input() dadosIdSelecionado!: any;
  @Input() pessoaIdSelecionado: any;
  @Input() entidadeIdSelecionado: any;

  outrosContatosVinculoForm!: FormGroup;
  contatoEditado: any;
  contatos: any[] = [];
  cidadeList: any[] = [];
  tipoContatoList: any[] = [];
  paisesList: any[] = [];
  ufList: any[] = [];
  ddiList: any[] = [];
  areaAtuacaoList: any[] = [];

  enderecoPessoaLista: any[] = [];
  enderecoEntidadeLista: any[] = [];
  enderecoVinculoLista: any[] = [];

  cep: string = '';
  tipoContatoSelecionada: any;
  acao!: RouteAction;
  inserir!: boolean;
  editar!: boolean;
  visualizar!: boolean;
  defaultPais: any;
  tipoContatoEnum = TipoContatoEnum;
  existeEndereco: boolean = false;

  cepToZipCode: boolean = false;

  previousEntidadeId: any;
  previousIdSelectPessoa: any;

  contadorCaracteres: number = 0;


  constructor(
    private fb: FormBuilder,
    private ufService: UFService,
    private paisService: PaisService,
    private tipoContatoService: TipoContatoService,
    private route: ActivatedRoute,
    private cepService: CEPService,
    private messageService: MessageService,
    private cidadeService: CidadeService,
    private areaAtuacaoService: AreaAtuacaoService,
    private entidadeSharedDataService: EntidadeSharedDataService,
    private vinculoService: VinculoService,
  ) { }

  ngAfterViewInit(): void {
    this.entidadeSharedDataService?.updateEmpresaEstrangeira$.subscribe(res => {
      if (res) {
        this.cepToZipCode = true;
      } else {
        this.cepToZipCode = false;
      }
    })
  }

  ngOnInit() {
    this.carregarListas();
    this.construirForm();

    this.enderecoUf?.valueChanges.subscribe((val: any) => {
      if (val?.id) {
        this.cidadeService.getCidadesByUf(val.id).subscribe(data => {
          this.cidadeList = data.sort((a: { nome: string; }, b: { nome: any; }) => a.nome.localeCompare(b.nome));
        });
      } else this.cidadeList = [];
    })

    this.paisControl?.valueChanges.subscribe((val: any) => {
      if (val?.id) {
        // console.log(val)
        this.outrosContatosVinculoForm.patchValue({ddi: val?.ddi});
      }
    });

    this.idEntidadeContatoControl?.valueChanges.subscribe((val: any) => {
      if (val) {
        const enderecoSet = this.enderecoEntidadeLista.find((item: any) => item?.id === val);
        const editObj = { ...enderecoSet };

        const telefoneSemCodArea = /^\d{4}[- ]?\d{4}$/;
        if (editObj?.telefone) {
          if (telefoneSemCodArea.test(editObj?.telefone.trim())) {
            editObj.telefone = `(00) ${editObj.telefone.replace(' ', '-')}`;
          }
        }
        // delete editObj.informacoesAdicionais;
        delete editObj.id;
        delete editObj.idEntidadeContato;
        delete editObj.idPessoaContato;
        delete editObj.idVinculo;
        this.outrosContatosVinculoForm.patchValue(editObj);



      }
    });

    this.idPessoaContatoControl?.valueChanges.subscribe((val: any) => {
      if (val) {
        const enderecoSet = this.enderecoPessoaLista.find((item: any) => item?.id === val);
        const editObj = { ...enderecoSet };

        const telefoneSemCodArea = /^\d{4}[- ]?\d{4}$/;
        if (editObj?.telefone) {

          if (telefoneSemCodArea.test(editObj?.telefone.trim())) {
            editObj.telefone = `(00) ${editObj.telefone.replace(' ', '-')}`;
          }
        }

        delete editObj.id;
        delete editObj.idEntidadeContato;
        delete editObj.idPessoaContato;
        delete editObj.idVinculo;
        this.outrosContatosVinculoForm.patchValue(editObj);
      }
    });

    this.idVinculoContatoControl?.valueChanges.subscribe((val: any) => {
      if (val) {
        const enderecoSet = this.enderecoVinculoLista.find((item: any) => item?.id === val);
        const editObj = { ...enderecoSet };

        const telefoneSemCodArea = /^\d{4}[- ]?\d{4}$/;
        if (editObj?.telefone) {

          if (telefoneSemCodArea.test(editObj?.telefone.trim())) {
            editObj.telefone = `(00) ${editObj.telefone.replace(' ', '-')}`;
          }
        }

        delete editObj.id;
        delete editObj.idEntidadeContato;
        delete editObj.idPessoaContato;
        delete editObj.idVinculo;
        this.outrosContatosVinculoForm.patchValue(editObj);
      }
    });
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (this.contato) {
      this.inserir = false;
      this.outrosContatosVinculoForm.patchValue(this.contato);
    } else {
      this.inserir = true;
    }

    if (this.dataSet.length) {
      this.existeEndereco = this.dataSet.some((item: any) => item.tipoContato?.id === TipoContatoEnum.ENDERECO);
    }

    const entidadeId =
      // this.data?.entidadeId ||
      this.dadosIdSelecionado?.entidadeId ||
      this.entidadeIdSelecionado;

    const idSelectPessoa =
      // this.data?.idSelectPessoa ||
      this.dadosIdSelecionado?.idSelectPessoa ||
      this.pessoaIdSelecionado;

    if (typeof entidadeId === 'number' && entidadeId !== this.previousEntidadeId) {
      this.previousEntidadeId = entidadeId;

      this.vinculoService.listarContatoEntidadeVinculo(entidadeId,false).subscribe((data: any) => {
        this.enderecoEntidadeLista = data;
      });
    }

    if (typeof idSelectPessoa === 'number' && idSelectPessoa !== this.previousIdSelectPessoa) {
      this.previousIdSelectPessoa = idSelectPessoa;

      this.vinculoService.listarContatoVinculoVinculo(idSelectPessoa).subscribe((data: any) => {
        this.enderecoVinculoLista = data;
      });
    }
  }


  construirForm() {
    this.outrosContatosVinculoForm = this.fb.group({
      id:[''],
      pais: [''],
      enderecoUf: [''],
      enderecoMunicipio: [''],
      enderecoBairro: [''],
      enderecoCep: [''],
      enderecoNumero: [''],
      enderecoLogradouro: [''],
      enderecoComplemento: [''],
      informacoesAdicionais: [''],
      ddi: [''],
      telefone: ['', CustomValidators.telefone],
      telefoneAdicional: [''],
      ddiFax: [''],
      fax: [''],
      faxAdicional: [''],
      siteUrl: [''],
      ramal: [''],
      tipoContato: ['', Validators.required],
      email: [''],
      escolherContato: [''],
      nomeContato: [''],
      observacao: ['',[Validators.maxLength(255)]],
      areaAtuacao: [''],
      idEntidadeContatoSelect: [],
      idPessoaContatoSelect: [],
      idVinculoContatoSelect: [],
    });
  }

  carregarListas(): void {
    this.paisService.listar().subscribe((ddi: any) => this.ddiList = ddi);

    const nomePaginaCapitalize = this.nomePagina.charAt(0).toUpperCase() + this.nomePagina.slice(1);
    this.tipoContatoService.tipoContatoTelaPermitidaList(nomePaginaCapitalize).subscribe((tipoContato: any) => this.tipoContatoList = tipoContato);

    forkJoin({
      enderecoUf: this.ufService.listar(),
      pais: this.paisService.listar(),
      areaAtuacao: this.areaAtuacaoService.listarAreaAtuacaoCombo()
    }).subscribe(({ enderecoUf, pais, areaAtuacao }) => {
      this.ufList = enderecoUf.sort((a, b) => a.nome.localeCompare(b.nome));
      this.paisesList = pais;
      this.areaAtuacaoList = areaAtuacao;
      const defaultPais = this.paisesList.find(pais => pais.nome === 'Brasil');
      if (defaultPais) {
        this.outrosContatosVinculoForm.patchValue({
          pais: defaultPais
        });
      }
    });
  }

  onTipoContatoChange(value: any): void {
    if (value !== undefined) {
      this.tipoContatoSelecionada = this.tipoContatoList.find((tipo: any) => tipo?.id === value?.id);
      this.updateFormFields();
    }
  }

  updateFormFields(): void {
    this.resetValidators();

    switch (this.tipoContatoSelecionada?.id) {
      case TipoContatoEnum.EMAIL:
        this.setEmailValidators();
        break;

      case TipoContatoEnum.TELEFONE:
        this.setTelefoneValidators();
        break;

      case TipoContatoEnum.ENDERECO:
        this.setEnderecoValidators();
        break;

      default:
        break;
    }

    this.setFormState();
    this.updateFormValidity();
  }
  atualizarContador() {
    const valor = this.outrosContatosVinculoForm.get('observacao')?.value || '';
    this.contadorCaracteres = valor.length;
  }

  resetValidators(): void {
    this.outrosContatosVinculoForm.get('email')?.clearValidators();
    this.outrosContatosVinculoForm.get('telefone')?.clearValidators();
    this.outrosContatosVinculoForm.get('pais')?.clearValidators();
    this.outrosContatosVinculoForm.get('enderecoUf')?.clearValidators();
    this.outrosContatosVinculoForm.get('enderecoMunicipio')?.clearValidators();
    this.outrosContatosVinculoForm.get('enderecoBairro')?.clearValidators();
    this.outrosContatosVinculoForm.get('enderecoCep')?.clearValidators();
    this.outrosContatosVinculoForm.get('enderecoLogradouro')?.clearValidators();
  }

  setEmailValidators(): void {
    this.outrosContatosVinculoForm.get('email')?.setValidators([
      Validators.required,
      Validators.email,
      Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}')
    ]);
  }

  setTelefoneValidators(): void {
    this.outrosContatosVinculoForm.get('telefone')?.setValidators([Validators.required]);

    if (this.existeEndereco) {
      const itemEndereco = this.dataSet.find((item: any) => item.tipoContato.id === TipoContatoEnum.ENDERECO);
      if (itemEndereco) {
        const ddiPais = this.ddiList.find((ddi: any) => ddi.id === itemEndereco.pais.id);
        if (ddiPais) {
          this.outrosContatosVinculoForm.patchValue({ ddi: ddiPais.ddi });
        }
      }
    }
  }

  setEnderecoValidators(): void {
    this.outrosContatosVinculoForm.get('pais')?.setValidators([Validators.required]);
    this.outrosContatosVinculoForm.get('enderecoUf')?.setValidators([Validators.required]);
    this.outrosContatosVinculoForm.get('enderecoMunicipio')?.setValidators([Validators.required]);
    this.outrosContatosVinculoForm.get('enderecoBairro')?.setValidators([Validators.required]);
    this.outrosContatosVinculoForm.get('enderecoCep')?.setValidators([Validators.required]);
    this.outrosContatosVinculoForm.get('enderecoLogradouro')?.setValidators([Validators.required]);
  }

  updateFormValidity(): void {
    this.outrosContatosVinculoForm.get('email')?.updateValueAndValidity();
    this.outrosContatosVinculoForm.get('telefone')?.updateValueAndValidity();
    this.outrosContatosVinculoForm.get('pais')?.updateValueAndValidity();
    this.outrosContatosVinculoForm.get('enderecoUf')?.updateValueAndValidity();
    this.outrosContatosVinculoForm.get('enderecoMunicipio')?.updateValueAndValidity();
    this.outrosContatosVinculoForm.get('enderecoBairro')?.updateValueAndValidity();
    this.outrosContatosVinculoForm.get('enderecoCep')?.updateValueAndValidity();
    this.outrosContatosVinculoForm.get('enderecoLogradouro')?.updateValueAndValidity();
  }

  compareFn(a: any, b: any): boolean {
    if (typeof a === 'boolean' && (typeof b === 'string' || typeof b === 'boolean')) {
      b = b === 'true';
    } if (a?.id !== undefined && b?.id !== undefined) {
      return a.id === b.id;
    } else if (a?.codigo !== undefined && b?.codigo !== undefined) {
      return a.codigo === b.codigo;
    } else if (a?.id !== undefined && b !== undefined) {
      return a.id === b;
    } else if (a !== undefined && b?.id !== undefined) {
      return a === b?.id;
    } else if (a?.uf !== undefined && b?.sigla !== undefined) {
      // console.log('a.uf', a.uf);
      return a?.uf === b?.sigla
    } else if (a?.cidade !== undefined && b?.nome !== undefined) {
      // console.log('a.cidade', a.cidade);
      // console.log('b.nome', b.nome);
      return a?.cidade === b?.nome && a?.uf === b?.uf.sigla
    } else {
      return a === b;
    }
  }

  setFormState(): void {
    if (this.visualizar) {
      this.outrosContatosVinculoForm.disable();
    }
  }

  salvar(): void {
    if(this.outrosContatosVinculoForm.valid) {
      let objEnvio = { ...this.outrosContatosVinculoForm.getRawValue() };

      this.dadosOutrosContatosEmit.emit(objEnvio);
      this.reset();
    }
  }

  reset() {
    this.inserir = true;

    // Object.keys(this.outrosContatosVinculoForm.controls).forEach(key => {
    //   const control = this.outrosContatosVinculoForm.get(key);
    //   if (control) {
    //     control.clearValidators();
    //     control.updateValueAndValidity({ emitEvent: true, onlySelf: true });
    //   }
    // });

    this.outrosContatosVinculoForm.reset();

    Object.keys(this.outrosContatosVinculoForm.controls).forEach(key => {
      const control = this.outrosContatosVinculoForm.get(key);
      if (control) {
        switch (key) {
          case 'tipoContato':
            control.setValidators(Validators.required);
            break;
          case 'ddi':
            control.setValidators(Validators.pattern(/^\+[1-9]\d{0,2}$/));
            break;
          case 'email':
            control.setValidators([Validators.email, Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}')]);
            break;
          default:
            break;
        }
        control.updateValueAndValidity({ emitEvent: true, onlySelf: true });
      }
    });
  }

  onCepBlur(): void {
    const cep = this.outrosContatosVinculoForm.get('enderecoCep')?.value;
    if (cep) {
      this.fetchCepData(cep);
    }
  }

  fetchCepData(cep: string): void {
    this.cepService.buscarEndereco(cep).subscribe(
      (data: any) => {
        if (!data.erro) {
          // console.log('CEP encontrado', data);

          // Encontrar a UF correspondente na lista de UFs
          const ufSelecionada = this.ufList.find(uf => uf.sigla === data.uf);
           // console.log('ufSelecionada', ufSelecionada);
          if (ufSelecionada && (!this.enderecoUf?.value || this.enderecoUf?.value.id !== ufSelecionada.id)) {
            this.enderecoUf?.patchValue(ufSelecionada); // Atualiza o valor do select de UF
            this.cidadeService.getCidadesByUf(ufSelecionada.id).subscribe(cidades => {
              this.cidadeList = cidades.sort((a: { nome: string; }, b: { nome: any; }) => a.nome.localeCompare(b.nome));
              this.setMunicipio(data); // Chamada para configurar a cidade após a atualização
            });
          } else {
            this.setMunicipio(data); // Caso a UF já esteja selecionada
          }

          this.outrosContatosVinculoForm.patchValue({
            enderecoLogradouro: data.logradouro,
            enderecoBairro: data.bairro,
          });
        } else {
          console.error('CEP não encontrado');
        }
      },
      (error) => {
        console.error('Erro ao buscar o CEP', error);
      }
    );
  }

  setMunicipio(data: any): void {
    const municipioSelecionado = this.cidadeList.find(cidade =>
      cidade.nome === data.cidade && cidade.uf.sigla === data.uf
    );

    this.outrosContatosVinculoForm.patchValue({
      enderecoMunicipio: municipioSelecionado || null,
      enderecoUf: municipioSelecionado?.uf || null,
    });
  }

  get paisControl() {
    return this.outrosContatosVinculoForm.get('pais');
  }

  get tipoContatoId() {
    const tipoContato = this.outrosContatosVinculoForm.get('tipoContato')?.value;
    this.dadosTipoContatoIdEmit.emit(tipoContato?.id);
    return tipoContato?.id;
  }

  get enderecoUf() {
    return this.outrosContatosVinculoForm.get('enderecoUf');
  }

  get escolherContatoControl() {
    return this.outrosContatosVinculoForm.get('escolherContato');
  }

  get idEntidadeContatoControl() {
    return this.outrosContatosVinculoForm.get('idEntidadeContatoSelect');
  }

  get idPessoaContatoControl() {
    return this.outrosContatosVinculoForm.get('idPessoaContatoSelect');
  }

  get idVinculoContatoControl() {
    return this.outrosContatosVinculoForm.get('idVinculoContatoSelect');
  }

}
